import { useEffect } from 'react';
import { $convertToMarkdownString } from '@lexical/markdown';
import { EDITOR_TRANSFORMER } from '../../utils/utils';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { BLUR_COMMAND, COMMAND_PRIORITY_EDITOR } from 'lexical';
type TextEventHandlerT = ({
  markdown,
  text,
  html
}: {
  markdown: string;
  text: string;
  html: string;
}) => void;
const OnBlurPlugin = ({
  onBlur
}: {
  onBlur: TextEventHandlerT;
}) => {
  const [editor] = useLexicalComposerContext();
  useEffect(() => {
    return editor.registerCommand(BLUR_COMMAND, () => {
      const editorState = editor.getEditorState();
      editorState.read(() => {
        const markdown = $convertToMarkdownString(EDITOR_TRANSFORMER).trim();
        const text = (editor.getRootElement()?.textContent?.toString() || '').trim();
        onBlur({
          text,
          markdown,
          html: ''
        });
      });
      return true;
    }, COMMAND_PRIORITY_EDITOR);
  }, [editor, onBlur]);
  return null;
};
export default OnBlurPlugin;